import NotificationsSerializer from './base';

export default class Notification extends NotificationsSerializer {}
